import { isUuidLike } from 'shared/utils/uuid'

/** Only null, undefined, or '' — not lodash isEmpty (which treats numbers, booleans, plain objects, etc. as empty). */
const isNilOrEmptyString = (v) => v == null || v === ''

/**
 * When `sa_meetings_page_with_supergraph` is on, `GET /api/dashboard/events/:eventId/invitees` must use
 * the publisher (non-UUID) event id. While `eventId` is still a GraphQL-style uuid, skip the request
 * to avoid a wrong-first fetch; call again once REST/supergraph supplies a real id.
 *
 * @param {boolean} supergraphMeetingsPageEnabled
 * @param {string | number | null | undefined} eventId — from {@link getDashboardEventIdForInvitees}
 * @returns {boolean} if true, pass as `skip` to `useGetInviteesQuery`
 */
export const shouldSkipDashboardInviteesForSupergraph = (supergraphMeetingsPageEnabled, eventId) => {
  if (!supergraphMeetingsPageEnabled) return false
  if (eventId == null || eventId === '') return false
  return isUuidLike(eventId)
}

const tryValue = (v) => {
  if (isNilOrEmptyString(v)) return undefined
  if (typeof v === 'number' && !Number.isNaN(v)) return v
  const s = String(v).trim()
  if (s.length === 0) return undefined
  if (isUuidLike(s)) return undefined
  if (/^\d+$/.test(s)) return s.length < 20 ? Number(s) : s
  return v
}

const keys = ['id', 'eventId', 'resourceId', 'scheduledEventId', 'legacyId', 'event_id', 'resource_id']

/**
 * Resolves the segment for `GET /api/dashboard/events/:eventId/invitees`.
 *
 * Publisher REST (scheduled event detail) is the SoT: it can expose a numeric or non-UUID `id` /
 * `eventId` distinct from the GraphQL `uuid`. Dashboard routes expect that id; using only
 * `uuid` matches a GraphQL id and is wrong for some orgs.
 *
 * @param {Record<string, unknown> | null | undefined} event — meeting from REST (and optional hints)
 * @returns {string | number | null}
 */
export function getDashboardEventIdForInvitees(event) {
  if (event == null) return null
  if (!isNilOrEmptyString(event.inviteesDashEventId)) return event.inviteesDashEventId
  for (const k of keys) {
    const picked = tryValue(event[k])
    if (picked !== undefined) return picked
  }
  if (!isNilOrEmptyString(event.uuid)) return event.uuid
  return null
}
